export default ({ app }) => {
  app.router.beforeEach(async (to, from, next) => {
    if (to.path === '/') {
      // valida primer ingreso
      const firstIn = localStorage.getItem('sf-session-first')

      if (!firstIn) {
        // localStorage.setItem('sf-session-first', false)
        return next('/register')
      }
      if (await app.$session.isValid()) return next('/dashboard')

      return next()
    }

    // el meta.auth se valida en el middleware auth.js en el componente
    // if (to.matched.some(record => record.meta.auth) && !app.$session.isValid()) {
    //   app.$session.setAuth(true)
    //   return next('/')
    // }

    return next()
  })
}
